/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiNoteFromJSON, StreemApiNoteToJSON, } from './';
export function StreemApiFinalizeRoomNoteResponseFromJSON(json) {
    return StreemApiFinalizeRoomNoteResponseFromJSONTyped(json, false);
}
export function StreemApiFinalizeRoomNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'note': !exists(json, 'note') ? undefined : StreemApiNoteFromJSON(json['note']),
    };
}
export function StreemApiFinalizeRoomNoteResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'note': StreemApiNoteToJSON(value.note),
    };
}
//# sourceMappingURL=StreemApiFinalizeRoomNoteResponse.js.map